import { render, staticRenderFns } from "./SenasoftTablero.vue?vue&type=template&id=41568910&scoped=true"
import script from "./SenasoftTablero.vue?vue&type=script&lang=js"
export * from "./SenasoftTablero.vue?vue&type=script&lang=js"
import style0 from "./SenasoftTablero.vue?vue&type=style&index=0&id=41568910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41568910",
  null
  
)

export default component.exports